/* Polsk katalog for locale-bank-misc-no.js (del 1 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'bank.analysis.running': 'Analizowanie …',
  'bank.analysis.completed': 'Przeanalizowane przez SuperPlumma',
  'bank.analysis.start': 'Rozpocznij analizę',
  'bank.analysis.retry': 'Ponów analizę',
  'bank.periodImport.dropFile': 'Upuść plik bankowy tutaj',
  'bank.periodImport.missingMonth': 'Brak wyciągu bankowego za {{period}}',
  'bank.periodImport.monthUploadHelp': 'Prześlij plik CSV, PDF lub XLSX dla {{account}}. Plik może obejmować jeden lub kilka miesięcy, niezależnie od wybranego miesiąca. Pozycje bankowe są automatycznie przypisywane do właściwego miesiąca według daty. Możesz też uzupełnić wcześniejszy import nowym wyciągiem.',
  'bank.periodImport.title': 'Prześlij plik bankowy',
  'bank.periodImport.help': 'Prześlij transakcje lub wyciągi za jeden lub więcej miesięcy. Przesyłanie nie zależy od wybranego miesiąca.',
  'bank.periodImport.chooseAccount': 'Wybierz rachunek bankowy',
  'bank.periodImport.coverageHelp': 'Sprawdź okres eksportu. Data pierwszej i ostatniej transakcji to tylko propozycja; dni bez transakcji też mogą być uwzględnione.',
  'bank.periodImport.from': 'Eksport od (włącznie)',
  'bank.periodImport.to': 'Eksport do (włącznie)',
  'bank.periodImport.confirmCoverage': 'Plik zawiera wszystkie operacje bankowe z tego okresu, bez filtrów wyszukiwania ani kwot.',
  'bank.periodImport.closing': 'Saldo końcowe banku (BZ)',
  'bank.periodImport.balanceHelp': 'Salda są opcjonalne przy imporcie. Użyj zaksięgowanego salda bankowego tuż przed datą początkową i na koniec daty końcowej. Pozostaw pole puste, jeśli saldo jest nieznane. Późniejszy wyciąg może uzupełnić BO/BZ.',
  'bank.periodImport.preview': 'Sprawdź import',
  'bank.periodImport.save': 'Importuj plik bankowy',
  'bank.periodImport.continue': 'Kontynuuj, gdzie skończyłem',
  'bank.periodImport.process': 'Przetwórz cały okres',
  'bank.periodImport.result': 'Nowe transakcje: {{added}} · rozpoznane: {{matched}}',
  'bank.periodImport.preserved': 'Wcześniejsze przetwarzanie, księgowania i powiązania z dowodami zostały zachowane.',
  'bank.periodImport.fileMissing': 'Transakcje zostały zapisane, ale nie udało się zapisać oryginalnego pliku. Prześlij plik ponownie, aby zachować dokumentację.',
  'bank.periodImport.monthLines': 'Pozycje: {{count}}',
  'bank.periodImport.balanceFound': 'BZ zarejestrowane',
  'bank.periodImport.balanceMissing': 'Brak salda bankowego',
  'bank.periodImport.chooseMatch': 'Wybierz istniejącą transakcję z innym opisem',
  'bank.periodImport.newTransaction': 'To osobna, nowa transakcja',
  'bank.periodImport.worklist': 'Bank · wspólna lista zadań',
  'bank.periodImport.worklistHelp': 'Przetwarzaj pozycje na bieżąco, niezależnie od miesiąca. Każdy miesiąc nadal ma własną kontrolę sald i uzgodnienie.',
  'bank.periodImport.needBalances': 'Brak salda bankowego. Możesz teraz przetworzyć pozycje i przed uzgodnieniem uzupełnić wyciąg lub udokumentowane BO/BZ.',
  'bank.periodImport.partial': 'To niepełny miesiąc. Przetwórz pozycje teraz i uzupełnij resztę miesiąca, zanim go zakończysz.',
  'bank.periodImport.files': 'Zaimportowane oryginalne pliki',
  'bank.periodImport.openPeriods': 'Otwórz zaimportowane okresy',
  'bank.control.ledgerDifference': '{{month}}: zaksięgowane BZ {{booked}}, BZ banku {{bank}}. Różnica {{difference}}. Miesiąc trzeba ponownie sprawdzić.',
  'bank.control.openingLedgerDifference': '{{month}}: BO banku {{bank}}, BO w księdze głównej {{booked}}. Różnica {{difference}}. Zarejestruj zbilansowany bilans otwarcia w sekcji Księgowość, zanim zakończysz uzgodnienie.',
  'bank.control.ledgerMismatchTitle': 'Różnica względem księgi głównej',
  'bank.archiveLedgerMismatch': 'Nie można zarchiwizować: zaksięgowane saldo na {{date}} wynosi {{booked}} kr, a saldo banku {{bank}} kr. Różnica {{difference}} kr.',
  'bank.statementDiscrepancy': 'Różnica w wyciągu',
  'bank.balanceDiscrepancy': 'Różnica salda',
  'bank.balanceDiscrepancyHelp': 'Różnica między zaksięgowanym saldem a saldem końcowym banku.',
  'bank.removedLineCannotBook': 'Błędnie odczytanej pozycji bankowej usuniętej z uzgodnienia nie można zaksięgować.',
  'bank.control.missingBalance': '{{month}}: w wyciągu bankowym brakuje BZ. Zaksięgowane BZ wynosi {{booked}}. Salda nie zostały ze sobą porównane.',
  'bank.control.ready': 'Wyciągi obejmują cały okres i są uzgodnione.',
  'bank.control.openingSetupMissing': 'Dla {{account}} brakuje daty rozpoczęcia lub salda początkowego. Uzupełnij oba w ustawieniach banku; wpisz 0, jeśli saldo wynosiło zero.',
  'bank.control.needsReview': 'Kontrola bankowa wykazała niepełne dane początkowe, brakujące wyciągi, nieuzgodnione okresy, różnice sald lub księgowania sprzed salda początkowego.',
  'bank.control.missing': 'Brak wyciągów bankowych za {{year}}: {{months}}.',
  'bank.control.unsettled': 'Wyciągi zostały przesłane, ale nie są w pełni uzgodnione za {{year}}: {{months}}.',
  'bank.control.existingBeforeStart': 'Liczba księgowań z datą sprzed salda początkowego {{date}}: {{count}}. Sprawdź księgowania i saldo początkowe w ustawieniach banku. Wcześniejsze księgowania nie zmieniają automatycznie salda początkowego.',
  'bank.control.postingBeforeStart': 'Księgowanie ma datę sprzed salda początkowego rachunku bankowego {{account}} ({{date}}). Sprawdź datę i saldo początkowe w ustawieniach banku, zanim zaksięgujesz.',
  'bank.patternBased': 'Na podstawie wcześniejszego wzorca',
  'bank.patternTitle': 'Wcześniejszy wzorzec',
  'bank.patternExplanation': 'Plumme proponuje takie ujęcie, ponieważ podobne pozycje bankowe były wcześniej księgowane w ten sam sposób. Propozycja nadal wymaga zatwierdzenia. Możesz wyłączyć wzorzec bez zmieniania wcześniejszych księgowań.',
  'bank.patternVariableAmounts': 'Plumme zapamiętuje typ i konto, ale nie używa ponownie wcześniejszych kwot rat kapitałowych, odsetek ani opłat. Kwoty trzeba za każdym razem sprawdzić z dokumentacją.',
  'bank.patternStop': 'Nie używaj wzorca',
  'bank.patternStopped': 'Wzorzec został wyłączony',
  'bank.patternStopFailed': 'Nie udało się wyłączyć wzorca.',
  'bank.backToYearClosing': 'Wróć do zamknięcia roku',
  'bank.editEntry': 'Edytuj księgowanie',
  'bank.bankLine': 'Pozycja bankowa',
  'bank.saveAndPost': 'Zapisz i zaksięguj',
  'bank.readFrom': 'Informacje odczytano z',
  'bank.voucherType': 'Typ dowodu',
  'bank.purchaseVoucher': 'Dowód zakupu',
  'bank.salesVoucher': 'Dowód sprzedaży',
  'bank.counterparty': 'Kontrahent',
  'bank.supplierOrParty': 'Dostawca / kontrahent',
  'bank.businessAccount': 'Rachunek firmowy',
  'bank.paidPrivately': 'Zapłacono prywatnie',
  'bank.uploadOrForward': 'Prześlij dowody lub przekaż je e-mailem — odczytamy, co się da.',
  'bank.uploadedReceived': 'Przesłano/odebrano',
  'bank.searchVouchers': 'Szukaj dowodów — nazwa pliku, PDF, obraz…',
  'bank.noInboxVouchers': 'Brak dowodów w skrzynce odbiorczej',
  'bank.noInboxVouchersHelp': 'Prześlij dowód lub przekaż faktury od dostawców na adres do dowodów.',
  'bank.allMonths': 'Wszystkie miesiące',
  'bank.uploading': 'Przesyłanie …',
  'bank.uploadingCount': 'Przesyłanie {{done}}/{{total}} …',
  'bank.analyzingCount': 'Analizowanie {{done}}/{{total}} …',
  'bank.dragToReorder': 'Przeciągnij, aby zmienić kolejność',
  'bank.editTheEntry': 'Edytuj księgowanie',
  'bank.moveToTrash': 'Przenieś do kosza',
  'bank.dropFilesHere': 'Upuść pliki tutaj',
  'bank.weReadWhatWeCan': 'Odczytamy, co się da',
  'bank.deleteForeverTitle': 'Usunąć na stałe?',
  'bank.deleteForever': 'Tak, usuń na stałe',
  'km.time': 'Czas',
  'km.avgSpeed': 'Średnia prędkość',
  'km.useDistance': 'Użyj dystansu',
  'km.searching': 'Wyszukiwanie...',
  'km.from': 'Skąd',
  'km.to': 'Dokąd',
  'km.resolvingAddress': 'Ustalanie adresu...',
  'km.gpsGapTitle': 'Luka w śladzie GPS',
  'km.gpsGap': 'Śledzenie utraciło po drodze pozycję i {km} km nie zostało uwzględnione. Sprawdź kilometry, zanim zapiszesz trasę.',
  'km.sub': 'Rejestruj przejazdy i miej kontrolę nad zwrotem kosztów przejazdu.',
  'km.newTripOrLog': 'Nowy przejazd / Ewidencja przebiegu',
  'km.newTripOrLogHelp': '„Nowy przejazd” rejestruje nowy przejazd. „Ewidencja przebiegu” pokazuje przegląd wszystkich zapisanych przejazdów z łącznym dystansem i odliczeniem.',
  'km.tripDetails': 'Szczegóły przejazdu',
  'km.tripDetailsHelp': 'Uzupełnij dane dokumentujące przejazd: datę, cel (dlaczego jechałeś), miejsce początkowe i docelowe oraz liczbę kilometrów. Cel jest ważny — przejazd musi być służbowy, aby dawał prawo do odliczenia.',
  'km.purposePh': 'Np. spotkanie z klientem w Lunde & Vik',
  'km.purposeQuickPicks': 'Szybki wybór',
  'km.returnTrip': 'Tam i z powrotem',
  'km.returnTripHelp': 'Zaznacz, jeśli wracałeś tą samą drogą. Kilometry i odliczenie zostaną podwojone, a przejazd zostanie udokumentowany w ewidencji przebiegu jako tam i z powrotem.',
  'km.returnTripRow': 'Tam i z powrotem',
  'km.perLeg': 'W jedną stronę',
  'km.removeStop': 'Usuń przystanek',
  'km.addStop': 'Dodaj przystanek',
  'km.addStopHelp': 'Dodaj przystanek między początkiem a celem — przydatne, gdy przejazd prowadzi przez kilka miejsc. Każdy przystanek staje się częścią dokumentowanej trasy.',
  'km.calcAuto': 'Oblicz km automatycznie',
  'km.calcAutoHelp': 'Automatycznie oblicza liczbę kilometrów między miejscem początkowym, przystankami i celem na podstawie map, więc nie musisz sam sprawdzać odległości.',
  'km.ratePerKm': 'Stawka za km',
  'km.ratePerKmHelp': 'Państwowa stawka zwrotu kosztów przejazdu za kilometr. Plumme automatycznie stosuje aktualną stawkę do obliczenia odliczenia.',
  'km.registeredDistance': 'Zarejestrowany dystans',
  'km.registeredDistanceHelp': 'Liczba kilometrów wprowadzona dla tego przejazdu.',
  'km.deductionAmount': 'Kwota odliczenia',
  'km.deductionAmountHelp': 'Kilometry pomnożone przez stawkę — kwota wolna od podatku, którą możesz otrzymać jako zwrot kosztów za ten przejazd.',
  'km.saveHelp': 'Zapisuje przejazd w ewidencji przebiegu. Wlicza się on do łącznego dystansu i odliczenia za rok i może zostać udokumentowany w razie kontroli.',
  'km.drivenThisYear': 'Przejechane w tym roku',
  'km.drivenThisYearHelp': 'Łączna liczba służbowych kilometrów zarejestrowanych w tym roku.',
  'km.deductionThisYear': 'Odliczenie w tym roku',
  'km.deductionThisYearHelp': 'Łączny zwrot kosztów przejazdu (odliczenie) za przejazdy zarejestrowane w tym roku.',
  'km.searchPh': 'Szukaj według trasy, celu lub daty',
  'km.deleteTripTitle': 'Usunąć przejazd?',
  'km.deleteTripConfirm': 'Tak, usuń',
  'bank.alreadyPostedToOperating': 'Już zaksięgowano na rachunku bieżącym',
  'bank.openInJournal': 'Otwórz w dzienniku dokumentów',
  'bank.noEntriesInView': 'Brak pozycji w tym widoku.',
  'bank.fixUp': 'Popraw',
  'bank.pickLine': 'Wybierz linię',
  'bank.noFreeLines': 'Brak wolnych linii bankowych w tym wyciągu.',
  'bank.link': 'Powiąż',
  'bank.statement': 'Wyciąg bankowy',
  'bank.openOriginal': 'Otwórz oryginał',
  'bank.downloadCsv': 'Pobierz CSV',
  'bank.openingBalance': 'Saldo początkowe',
  'bank.originalNotDownloadable': 'Nie można pobrać oryginalnego pliku.',
  'bank.viewUsesImported': 'Poniższy widok korzysta z już zaimportowanych linii bankowych.',
  'bank.balance': 'Saldo',
  'bank.noImportedLines': 'Brak zaimportowanych linii bankowych w tym wyciągu.',
  'bank.importNoTransactions': 'Nie znaleziono transakcji w „{{fileName}}”, ale salda wskazują ruch w wysokości {{difference}}. Sprawdź linie z oryginałem przed uzgodnieniem. Wyciąg nie został zapisany.',
  'bank.importBalanceMismatch': 'Odczytane linie nie zgadzają się z saldami w wyciągu: różnica {{difference}}. Sprawdź linie z oryginałem przed uzgodnieniem. Wyciąg nie został zapisany.',
  'bank.importUnreadablePeriod': 'Nie udało się odczytać okresu z wyciągu bankowego. Wyciąg nie został zapisany.',
  'bank.imageAnalysisUnavailable': 'Analiza obrazów wyciągów bankowych nie jest jeszcze dostępna.',
  'bank.importFailed': 'Nie udało się odczytać wyciągu bankowego.',
  'bank.readingStatement': 'Odczytywanie wyciągu…',
  'bank.openStatementPreview': 'Otwórz podgląd wyciągu bankowego',
  'bank.seeOriginal': 'Zobacz wyciąg',
  'bank.almostDone': 'Prawie gotowe',
  'bank.linesRemaining': 'linii pozostało do obsłużenia',
  'bank.discrepancy': 'Rozbieżność',
  'bank.discrepancyHelp': 'Obliczona rozbieżność między saldem a liniami bankowymi',
  'bank.openingBalanceHelp': 'Saldo rachunku bankowego na początku okresu — pobrane z poprzedniego uzgodnienia.',
  'bank.closingBalanceHelp': 'Saldo rachunku bankowego na koniec okresu według wyciągu bankowego. Musi się zgadzać z saldem zaksięgowanym po obsłużeniu wszystkich linii.',
  'bank.useSuperPlumma': 'Użyj SuperPlumma',
  'bank.useSuperPlummaHelp': 'Pozwala SuperPlumma znaleźć propozycje do sprawdzenia. Zatwierdzasz wynik przed zaksięgowaniem.',
  'bank.reconcileAndPost': 'Uzgodnij i zaksięguj',
  'bank.chronologicalTitle': 'Wcześniejszy okres nie jest uzgodniony',
  'bank.chronologicalBody': 'Najpierw uzgodnij {{period}}. Saldo początkowe pochodzi z poprzedniego wyciągu, więc rozbieżność w nim byłaby tutaj niewidoczna.',
  'bank.reconcileAndPostHelp': 'Księguje linie bankowe, blokuje okres po obsłużeniu wszystkich linii i przenosi wyciąg do archiwum.',
  'bank.reconcileAndArchive': 'Uzgodnij i zarchiwizuj',
  'bank.reconcileAndArchiveHelp': 'Księguje linie bankowe, blokuje okres po obsłużeniu wszystkich linii i przenosi wyciąg do archiwum.',
  'bank.existingEntryMatch.action': 'Dopasuj zaksięgowaną pozycję',
  'bank.existingEntryMatch.title': 'Dopasuj zaksięgowaną pozycję',
  'bank.existingEntryMatch.help': 'Wybierz pozycję, która już księguje tę samą kwotę bankową. Nie zostanie utworzone nowe księgowanie.',
  'bank.existingEntryMatch.dateMismatch': 'Data różni się o {days} dni. Sprawdź pozycję przed powiązaniem.',
  'bank.existingEntryMatch.none': 'Nie znaleziono zaksięgowanych pozycji z tą samą kwotą i zbliżoną datą.',
  'bank.existingEntryMatch.success': 'Linia bankowa została powiązana z zaksięgowaną pozycją.',
  'bank.existingEntryMatch.error': 'Nie udało się powiązać linii bankowej.',
  'bank.reopenAndReverse': 'Otwórz i odwróć',
  'bank.reopenAndReverseHelp': 'Ponownie otwiera uzgodniony wyciąg bankowy, aby można było poprawić księgowania. Okres zostanie odblokowany.',
  'bank.settledTitle': 'Uzgodnione i zaksięgowane',
  'bank.settledOn': 'Zarchiwizowano {{date}}',
  'bank.settledHelp': 'Wyciąg znajduje się w archiwum.',
  'bank.settledBadge': 'Uzgodnione',
  'bank.alreadySettled': 'Ten wyciąg bankowy jest już uzgodniony i zarchiwizowany. Otwórz go ponownie, jeśli coś trzeba poprawić.',
  'bank.postedToOperating': 'Zaksięgowano na rachunku bieżącym',
  'bank.postedToOperatingHelp': 'Te pozycje zostały zaksięgowane na rachunku bieżącym dla tego okresu bankowego.',
  'bank.linkVoucher': 'Powiąż',
  'bank.openLinkedVoucher': 'Otwórz {{name}}',
  'bank.openingBalanceImported': 'Odczytano z wyciągu: {{amount}}',
  'bank.useExpectedOpening': 'Ustaw saldo początkowe na {{amount}}',
  'bank.receiptLinked': 'Powiązano z linią bankową',
  'bank.duplicateUpload': 'Możliwe podwójne przesłanie',
  'bank.ambiguousMatch': 'Kilka identycznych dokumentów — wybierz sam, który pasuje',
  'bank.linkSuggestedVouchers': 'Powiąż proponowane dokumenty ({{count}})',
  'bank.searchLines': 'Szukaj w liniach bankowych…',
  'bank.addLine': 'Dodaj linię bankową',
  'bank.noLinesInView': 'Brak linii bankowych w tym widoku.',
  'bank.missingVoucher': 'Brak dokumentu',
  'bank.missingVoucherAction': 'Brak dokumentu · kliknij lub przeciągnij tutaj',
  'bank.missingVoucherHelp': 'Przeciągnij tutaj dokument ze skrzynki odbiorczej, aby go powiązać. Jeśli dokument zaginął lub nie można go uzyskać, kliknij, aby zarejestrować go jako utracony.',
  'bank.markVoucherLostTitle': 'Oznacz dokument jako zagubiony',
  'bank.markVoucherLostHelp': 'Księgowanie zostaje zachowane, ale nie zastępuje to dokumentacji. Działanie następcze zostaje zamknięte, a wybór jest zapisywany przy wierszu bankowym wraz z uzasadnieniem, czasem i użytkownikiem.',
  'bank.markVoucherLostConfirm': 'Zarejestruj',
  'bank.markVoucherLostSaving': 'Rejestrowanie …',
  'bank.voucherLostReason': 'Wyjaśnienie',
  'bank.voucherLostReasonHint': 'Wymagane. Wyjaśnij, dlaczego nie można uzyskać dokumentu.',
  'bank.voucherLostReasonPlaceholder': 'Np. paragon zaginął, a dostawca nie może przesłać kopii.',
  'bank.voucherLostReasonRequired': 'Krótko wyjaśnij, dlaczego nie można uzyskać dokumentu.',
  'bank.voucherLostError': 'Nie udało się oznaczyć dokumentu jako zagubionego.',
  'bank.voucherLostUnavailable': 'Oznaczanie dokumentu jako zagubionego nie jest podłączone do backendu.',
  'bank.docReason.lostText': 'Dokument zaginął i nie można go uzyskać.',
  'bank.docReason.never': 'Nigdy nie otrzymano',
  'bank.docReason.neverText': 'Dostawca nie przesłał paragonu ani faktury.',
  'bank.docReason.statementOnly': 'Tylko na wyciągu bankowym',
  'bank.docReason.statementOnlyText': 'Transakcja widnieje tylko na wyciągu bankowym i nie ma osobnego dokumentu.',
  'bank.docReason.notApplicable': 'Nie dotyczy',
  'bank.docReason.notApplicableText': 'Osobny dokument nie dotyczy tego księgowania.',
  'bank.voucherMarkedLost': 'Dokument zagubiony',
  'bank.voucherMarkedLostToast': 'Dokument oznaczono jako zagubiony',
  'bank.sendVoucherBack': 'Odeślij dokument do skrzynki odbiorczej',
  'bank.approveSuggestion': 'Zatwierdź propozycję',
  'bank.approveSuggestionHelp': 'Akceptuje propozycję dekretacji SuperPlummy dla wiersza i księguje go w ten sposób.',
  'bank.review': 'Sprawdź',
  'bank.markPrivate': 'Oznacz jako prywatne',
  'bank.post': 'Zaksięguj',
  'bank.reviewEntries': 'Sprawdź pozycje',
  'bank.previewUnavailable': 'Podgląd jest niedostępny',
  'bank.previewUnavailableHelp': 'Dokument nie ma dostępnego adresu pliku.',
  'bank.noVatCalculated': 'VAT nie jest naliczany. Cała kwota bankowa w wysokości',
  'bank.amountExVatBecomes': 'Kwota bez VAT wynosi',
  'bank.actualAmountIncVat': 'Rzeczywista kwota bankowa z VAT wynosi',
  'bank.saveAndClose': 'Zapisz i zamknij',
  'bank.manualLine': 'Ręczny wiersz bankowy',
  'bank.amountExInc': 'Kwota bankowa bez/z VAT',
  'bank.amountExIncHelp': 'Dotknij, aby przełączyć wyświetlanie kwoty z VAT lub bez VAT. Plumme przelicza automatycznie, a rzeczywista kwota z transakcji bankowej jest nadal zapisywana z VAT.',
  'bank.costAccount': 'Konto kosztowe',
  'bank.accountCategory': 'Konto/kategoria',
  'bank.salesAccount': 'Konto sprzedaży',
  'bank.pickOpenInvoice': 'Wybierz otwartą fakturę',
  'bank.noMatchingInvoices': 'Żadna otwarta faktura nie pasuje do tej kwoty.',
  'bank.matchesVatPeriod': 'Pasuje do wybranego okresu VAT. Zaksięgowanie i oznaczenie jako zapłacone nastąpi po powiązaniu okresu.',
  'bank.mixedUseManual': 'Jeśli wiersz łączy VAT, podatek, korekty lub inne dostosowania, użyj księgowania ręcznego.',
  'bank.matchesPayrollPeriod': 'Pasuje do wybranego okresu zaliczki na podatek/AGA. Wybierz, którą część wiersz bankowy faktycznie opłaca.',
  'bank.payrollPeriod': 'Okres zaliczki na podatek / AGA',
  'bank.whatIsPaymentFor': 'Czego dotyczy płatność?',
  'bank.payrollAccountsHelp': 'Zaliczka na podatek to 2600, składka pracodawcy to 2770.',
  'bank.feeHelp': 'Użyj tego dla opłat bankowych i kartowych. Kwota jest księgowana bez VAT na konto',
  'bank.noFeeAccount': 'W planie kont nie ma odpowiedniego konta opłat.',
  'bank.roundingHelp': 'Używaj tego tylko dla rzeczywistej niewielkiej różnicy z zaokrąglenia. Kwota jest księgowana bez VAT na konto',
  'bank.swapFromTo': 'Zamień skąd i dokąd',
  'bank.pickTwoAccounts': 'Wybierz dwa różne konta przed zapisaniem księgowania ręcznego.',
  'bank.manualPostingBankMismatch': 'Suma na koncie bankowym w księgowaniu musi być równa wierszowi bankowemu.',
  'bank.supplierVatHelp': 'Stawka VAT na fakturze dostawcy. VAT naliczony jest obliczany z kwoty.',
  'bank.supplierDueDateHelp': 'Termin płatności na fakturze dostawcy. Jeśli wiersz bankowy pokrywa tylko część kwoty, reszta pozostaje pozycją otwartą — a od tego terminu liczona jest struktura wiekowa.',
  'bank.supplierInvoiceGross': 'Łączna kwota faktury',
  'set.bank.currency': 'Waluta',
  'set.bank.accountNumberHelp': 'Numer konta w formie podanej przez bank. Kropki i spacje są usuwane automatycznie — księgowość, pliki importu i płatności porównują cyfry, a numer z separatorami nie pasuje do własnego wyciągu.',
  'set.bank.currencyName.NOK': 'Korony norweskie',
  'set.bank.currencyName.SEK': 'Korony szwedzkie',
  'set.bank.currencyName.DKK': 'Korony duńskie',
  'set.bank.currencyName.EUR': 'Euro',
  'set.bank.currencyName.USD': 'Dolary amerykańskie',
  'set.bank.currencyName.GBP': 'Funty brytyjskie',
  'set.bank.currencyName.CHF': 'Franki szwajcarskie',
  'set.bank.currencyName.ISK': 'Korony islandzkie',
  'set.bank.currencyName.PLN': 'Złote polskie',
  'set.bank.currencyName.CZK': 'Korony czeskie',
  'set.bank.currencyName.JPY': 'Jeny japońskie',
  'set.bank.currencyName.CAD': 'Dolary kanadyjskie',
  'set.bank.currencyName.AUD': 'Dolary australijskie',
  'set.loans.title': 'Rejestr kredytów',
  'set.loans.sub': 'Kredyty i zobowiązania długoterminowe z harmonogramem spłat',
  'set.loans.help': 'W przeciwnym razie kredyt jest tylko kontem księgi głównej. Saldo mówi, ile pozostało, ale nie ile przypada do spłaty w ciągu najbliższego roku — a bez tego nie da się rozdzielić zobowiązań krótko- i długoterminowych. Raty księguje się jak dotąd, przez bank lub dokument.',
  'set.loans.none': 'Brak zarejestrowanych kredytów.',
  'set.loans.add': 'Dodaj kredyt',
  'set.loans.remove': 'Usuń kredyt',
  'set.loans.lender': 'Kredytodawca',
  'set.loans.ledgerAccount': 'Konto księgi głównej',
  'set.loans.ledgerAccountHelp': 'Konto, na którym ujęty jest kredyt. Bez niego kredytu nie można uzgodnić z księgowością.',
  'set.loans.missingAccount': 'Brak konta',
  'set.loans.originalAmount': 'Pierwotna kwota kredytu',
  'set.loans.interestRate': 'Oprocentowanie (%)',
  'set.loans.startDate': 'Data rozpoczęcia',
  'set.loans.repaymentType': 'Rodzaj spłaty',
  'set.loans.termsPerYear': 'Raty w roku',
  'set.loans.monthly': 'Miesięcznie (12)',
  'set.loans.quarterly': 'Kwartalnie (4)',
  'set.loans.halfYearly': 'Półrocznie (2)',
  'set.loans.yearly': 'Rocznie (1)',
  'set.loans.installmentAmount': 'Kwota raty',
  'set.loans.installmentHelp': 'Rata kapitałowa na okres dla kredytu z ratami malejącymi, cała rata dla kredytu z ratami równymi.',
  'set.loans.remainingTerms': 'Pozostałe raty',
  'set.loans.interestOnlyUntil': 'Karencja w spłacie do',
  'set.loans.interestOnlyHelp': 'Pozostaw puste, jeśli kredyt nie ma karencji w spłacie.',
  'set.loans.security': 'Zastaw i zabezpieczenia',
  'set.loans.planIncomplete': 'Harmonogram nie jest wystarczająco kompletny, aby obliczyć, co przypada do spłaty w ciągu najbliższego roku. Uzgodnienie zgłasza to zamiast zgadywać.',
  'set.loans.planSays': 'Według harmonogramu w ciągu najbliższych dwunastu miesięcy przypada do spłaty {amount}. Klasyfikacja jako krótko- lub długoterminowe nadal jest oceną merytoryczną.',
  'set.bank.currencyHelp': 'Własna waluta konta. NOK dla zwykłych kont norweskich. Konto w innej walucie uzgadnia się przez przeliczenie po kursie z dnia bilansowego, a nie przez bezpośrednie porównanie.',
  'bank.supplierInvoiceGrossHelp': 'Wypełnij tylko, jeśli wiersz bankowy pokrywa część faktury. Faktura zostanie wtedy zarejestrowana na pełną kwotę, a to, co opłaca wiersz bankowy, zostanie zaksięgowane jako płatność częściowa — reszta pozostaje do zapłaty dostawcy.',
  'bank.shortDescriptionPh': 'Krótki opis transakcji…',
  'bank.previewVoucher': 'Podgląd dokumentu',
  'bank.noVoucherUploaded': 'Nie przesłano dokumentu',
  'bank.fetchFromInbox': 'Pobierz ze skrzynki odbiorczej',
  'bank.backToBank': 'Wróć do Banku',
  'bank.privateBank': 'Bank prywatny',
  'bank.privateBankHelp': 'Konto prywatne służy jako narzędzie porządkowe: przejrzyj wiersze, oznacz te, które w rzeczywistości są wydatkami firmowymi, jako „Działalność” (zostaną wtedy zaksięgowane na koncie działalności), a czysto prywatne zignoruj. W ten sposób uwzględnisz koszty firmowe, które zapłaciłeś prywatnie.',
  'bank.finishReview': 'Zakończ przegląd',
  'bank.finishReviewHelp': 'Księguje na rachunek firmowy pozycje oznaczone jako firmowe i archiwizuje przejrzany wyciąg prywatny.',
  'bank.dragVoucherFromInbox': 'Przeciągnij dowód księgowy ze skrzynki odbiorczej',
  'bank.toOperations': 'Do firmy',
  'bank.toOperationsHelp': 'Otwiera opcje księgowania pozycji, aby konto, VAT, dowód księgowy i typ były poprawne, zanim zostanie przeniesiona do firmy.',
  'bank.ignore': 'Ignoruj',
  'bank.ignoreHelp': 'Oznacza pozycję jako czysto prywatną i wyłącza ją z księgowości firmy. Dotknij ponownie, aby cofnąć.',
  'bank.voucherReceivedOn': 'Dowód księgowy otrzymany',
  'bank.superPlummaFetches': 'SuperPlumma pobiera i łączy',
  'bank.searchInbox': 'Szukaj w skrzynce odbiorczej...',
  'bank.reopen': 'Otwórz ponownie',
  'bank.viewPostings': 'Zobacz księgowania',
  'bank.waitingPrevious': 'Czeka na poprzedni',
  'bank.waitingPreviousHelp': 'Możesz teraz otworzyć i sprawdzić wyciąg, ale nie można go zaksięgować ani uzgodnić, dopóki poprzedni wyciąg nie zostanie zakończony.',
  'bank.previousMustReconcile': 'Najpierw trzeba uzgodnić poprzedni wyciąg bankowy. Możesz sprawdzić ten wyciąg, ale jeszcze nie możesz go zaksięgować ani uzgodnić.',
  'bank.openStatement': 'Otwórz wyciąg bankowy',
  'bank.deleteStatement': 'Usuń wyciąg',
  'bank.deleteStatementTitle': 'Usunąć wyciąg bankowy?',
  'bank.deleteStatementConfirm': '{{fileName}} zostanie trwale usunięty. Zaksięgowane zapisy i dowody księgowe nie zostaną usunięte, ale stracą powiązanie z wyciągiem. Pozostaną bez uzgodnienia bankowego, dopóki nie prześlesz wyciągu za ten okres — wtedy zostaną dopasowane automatycznie lub pokazane jako rozbieżności. Tej operacji nie można cofnąć.',
  'bank.statementFallback': 'Wyciąg bankowy',
  'bank.deleteUnavailable': 'Usuwanie wyciągów bankowych nie jest jeszcze dostępne.',
  'bank.deleteSuccess': 'Wyciąg bankowy został usunięty',
  'bank.deleteReopenFirst': 'Otwórz ponownie wyciąg bankowy, zanim go usuniesz.',
  'bank.deleteNewerFirst': 'Najpierw trzeba usunąć nowsze wyciągi bankowe. Przetworzone wyciągi usuwa się od najnowszego do najstarszego.',
  'bank.deleteError': 'Nie udało się usunąć wyciągu bankowego.',
  'bank.deleteSettledBlocked': 'Uzgodnionych lub zaksięgowanych wyciągów bankowych nie można usunąć.',
  'bank.deleteReverseFirst': 'Księgowanie musi zostać wycofane, zanim będzie można usunąć wyciąg bankowy.',
  'bank.deleteMatchGroupBlocked': 'Wyciąg bankowy należy do zaksięgowanej grupy dopasowań. Wycofaj grupę przed usunięciem wyciągu.',
  'bank.deleteMatchGroupOffline': 'Wyciąg bankowy należy do grupy dopasowań. Spróbuj ponownie, gdy będziesz online.',
  'bank.noArchivedStatements': 'Brak zarchiwizowanych wyciągów bankowych.',
  'bank.archivedHelp': 'W pełni uzgodnione okresy trafiają tutaj, gdy wszystkie pozycje zostaną obsłużone i zarchiwizowane.',
  'bank.uploadFile': 'Prześlij plik',
  'bank.opPrivArchive': 'Firma / Prywatne / Archiwum',
  'bank.opPrivArchiveHelp': '„Firma” uzgadnia rachunek firmowy. „Prywatne” służy do porządkowania rachunku prywatnego i przenoszenia pozycji związanych z firmą do firmy. „Archiwum” pokazuje w pełni uzgodnione wyciągi.',
  'bank.privateNotLinked': 'Rachunek prywatny jest osobisty i nie jest powiązany z rachunkiem bankowym firmy.',
  'bank.bankAccount': 'Rachunek bankowy',
  'bank.bankAccountHelp': 'Wybierz rachunek bankowy, który uzgadniasz. Każdy rachunek ma własny numer w planie kont (np. 1920 rachunek firmowy, 1950 rachunek potrąceń podatkowych) i własne wyciągi.',
  'bank.noAccountsSetUp': 'Nie skonfigurowano żadnych rachunków bankowych',
  'bank.noStatements': 'Brak wyciągów bankowych.',
  'bank.noStatementsHelp': 'Prześlij plik bankowy dla wybranego rachunku lub sprawdź, czy wybrano właściwą firmę.',
  'bank.connectBank': 'Połącz z bankiem',
  'bank.connectBankHelp': 'Połącz Plumme bezpośrednio ze swoim bankiem przez bezpieczny Open Banking. Transakcje będą wtedy pobierane automatycznie, a SuperPlumma będzie je na bieżąco księgować i uzgadniać — nie musisz ręcznie przesyłać wyciągów.',
  'bank.connectYourBank': 'Połącz ze swoim bankiem',
  'bank.connect': 'Połącz',
  'altinn.sub': 'Przekazuj formularze do urzędów — wypełniamy z góry to, co możemy.',
  'altinn.filingVia': 'Składanie przez Altinn',
  'altinn.open': 'Otwórz Altinn',
  'altinn.openHelp': 'Otwiera portal Altinn w nowej karcie, gdzie logujesz się swoim identyfikatorem i kończysz składanie wstępnie wypełnionych formularzy.',
  'altinn.formsAndStatus': 'Formularze i status',
  'altinn.formsAndStatusHelp': 'Przegląd urzędowych formularzy, które firma musi złożyć, z numerem referencyjnym RF i statusem. Status pokazuje, czy formularz został złożony, wkrótce mija termin, czy jeszcze nie został złożony.',
  'altinn.form': 'Formularz',
  'altinn.formHelp': 'Nazwa urzędowego formularza. Numer RF w następnej kolumnie to oficjalne oznaczenie formularza nadane przez Skatteetaten.',
  'altinn.statusHelp': '„Złożono” oznacza, że formularz został wysłany, „Wkrótce termin” zbliża się do terminu, a „Nie złożono” wciąż czeka na wysłanie.',
  'setl.sub': 'Firma, faktury, bank i powiadomienia - wszystko w jednym miejscu.',
  'setl.companyInfo': 'Dane firmy',
  'setl.companyName': 'Nazwa firmy',
  'setl.invoiceSettings': 'Ustawienia faktur',
  'setl.nextInvoiceNo': 'Następny numer faktury',
  'setl.defaultPaymentTerms': 'Domyślny termin płatności',
  'setl.defaultVatRate': 'Domyślna stawka VAT',
  'setl.reminderFee': 'Opłata za monit',
  'setl.sendCopyToMe': 'Wyślij mi kopię',
  'setl.sendCopyHelp': 'Otrzymuj kopię każdej faktury e-mailem.',
  'setl.bankAndAccount': 'Bank i rachunek',
  'setl.mainLedgerAccount': 'Konto główne w księgowości',
  'setl.notifications': 'Powiadomienia',
  'km.pageHelp': 'Ewidencja przebiegu dokumentuje jazdy służbowe i prywatne użytkowanie samochodu firmowego. Jazdy służbowe uprawniają do zwrotu kosztów według stawki państwowej, a jazdy prywatne są rejestrowane bez odliczenia.',
  'km.newTrip': 'Nowa trasa',
  'km.tripType': 'Rodzaj trasy',
  'km.typeBusiness': 'Służbowa',
  'km.typePrivate': 'Prywatna',
  'km.privateUse': 'Użytek prywatny',
  'km.privatePurposePh': 'Użytek prywatny (opcjonalnie)',
  'km.privateNote': 'Jazdy prywatne są rejestrowane, ale nie dają odliczenia i nie są księgowane.',
  'km.ownCar': 'Własny samochód',
  'km.startPlace': 'Miejsce startu',
  'km.stopN': 'Przystanek {n}',
  'km.stopPh': 'Adres po drodze',
  'km.destination': 'Cel',
  'km.calculating': 'Obliczanie...',
  'km.saveChanges': 'Zapisz zmiany',
  'km.saveEntry': 'Zapisz wpis w ewidencji przebiegu',
  'km.privateDriving': 'Jazda prywatna',
});
